import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import API from "../../../api/client";
import * as ENDPOINTS from "../../../api/endpoints";

const QuotePdf = () => {
  const buttonRef = useRef(null);
  const [downloadUrl, setDownloadUrl] = useState();
  const params = useParams();
  const getQuote = async () => {
    const url = `${ENDPOINTS.QUOTE_PDF}/${params.quote_id}`;
    try {
      const response = await API.getFile(url, {
        responseType: "blob",
      });
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(pdfBlob);
      setDownloadUrl(blobUrl);
      buttonRef.current.click();
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  useEffect(() => {
    getQuote();
  }, []);

  const linkStyle = {
    display: "none",
  };

  return (
    <>
      {downloadUrl && (
        <a href={downloadUrl} ref={buttonRef} style={linkStyle}>
          Prind PDF
        </a>
      )}
    </>
  );
};

export default QuotePdf;
